import React from "react";

/**
 * Custom rocket SVG with brand-pink → magenta gradient fill.
 * Animates a small lift + rotate on hover when wrapped in a `.group` parent.
 */
export default function RocketIcon({ size = 28, className = "", id = "rk" }) {
  const gid = `rocket-grad-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={`transition-transform duration-300 ease-out group-hover:-translate-y-0.5 group-hover:rotate-[8deg] ${className}`}
    >
      <defs>
        <linearGradient id={gid} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF6B9D" />
          <stop offset="55%" stopColor="#EE4F7A" />
          <stop offset="100%" stopColor="#8B3D9E" />
        </linearGradient>
      </defs>
      {/* Rocket body */}
      <path
        d="M16 2.5c4.4 4 6.6 8 6.6 12.2 0 1.7-.3 3.3-.9 4.7l1.7 1.7-2.5 2.5-1.7-1.7c-1.4.6-3 .9-4.7.9-1.7 0-3.3-.3-4.7-.9l-1.7 1.7-2.5-2.5 1.7-1.7c-.6-1.4-.9-3-.9-4.7 0-4.2 2.2-8.2 6.6-12.2.4-.4 1.1-.4 1.5 0Z"
        fill={`url(#${gid})`}
      />
      {/* Window */}
      <circle cx="16" cy="13" r="2.4" fill="#FFF9F4" />
      <circle cx="16" cy="13" r="1.2" fill="#55D9C2" />
      {/* Left fin */}
      <path d="M9.4 19.5l-3 3.4 1.6 4.1 4-2.5-2.6-5Z" fill="#0F0E14" />
      {/* Right fin */}
      <path d="M22.6 19.5l3 3.4-1.6 4.1-4-2.5 2.6-5Z" fill="#0F0E14" />
      {/* Flame */}
      <path
        d="M14 24.5c.3 2 .9 3.4 2 4.4 1.1-1 1.7-2.4 2-4.4-.7.3-1.3.5-2 .5s-1.3-.2-2-.5Z"
        fill="#FCD34D"
      />
    </svg>
  );
}
